import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect } from "react";
import FormRow from "components/form/FormRow";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Insumo from "entity/Insumo";
import AVL from "..";
import Operador from "entity/Operador";

export default function EditFields({ visita, TipoClass }) {
    console.log("visita", visita.data);
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(AVL, tipo, TipoClass);

    const [apontamento] = useFieldValue();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = AVL.calcConformidade(apontamento, params);
        }
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} />

            <ApontamentoAmostraParams>
                <FormRow>
                    <EntitySearchInput name="insumo" label="Insumo" EntityClass={Insumo} />
                </FormRow>

                <FormRow>
                    <TextInput type="number" name="dosagemRecomendada" label="Dosagem Recomendada" />
                </FormRow>

                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="I. A.:">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="M. L. H.:">{params.metrosLinearesHectare}</ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="pesagem" label="Pesagem" />
                <TextInput type="number" name="metrosLinearesAmostra" label="Metros Lineares por Amostra" />
            </ApontamentoColetas>

            <ApontamentoResultado>
                <FormRow>
                    <TextInput name="afericao" label="Aferição" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="media" label="Média" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="doseMetro" label="Dose por Metro" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
